import './styles.scss'

import Label from "components/Label";
// import { data } from './mockData'
import UseCaseItem from './UseCaseItem';
import UseCaseNavItem from './UseCaseNavItem';
import { useRef } from 'react';
import { useAnimation } from 'hooks/useAnimation';



const UseCases = ({ useCases, isLoading }) => {

    const container = useRef();

    useAnimation({
        items: ['.usecase h2', '.usecase-cases-item', '.usecase-cases-navitem'],
        container,
        dependencies: [isLoading],
    })


    const { tag, title, contact_sales_title, contact_sales_text, contact_sales_button, contact_sales_button_link, use_case_card } = useCases
    return (
        <section ref={container} className="inner-container usecase">
            <Label text={tag} />
            <h2>{title}</h2>
            <div className="usecase-cases">
                {
                    use_case_card?.map((item, index) => (
                        <UseCaseItem key={index} data={item} />
                    ))
                }
                <UseCaseNavItem
                    navTitle={contact_sales_title}
                    navDesc={contact_sales_text}
                    navBtnText={contact_sales_button}
                    navLink={contact_sales_button_link} />
            </div>
        </section>
    );
}

export default UseCases;